<template>
  <div class="surface-design-colors">
    <TopPanel
      @search="surfaceDesignColorsStore.searchByCollections"
      @sort-order="surfaceDesignColorsStore.setSortOrderCollections"
      @sort-option="surfaceDesignColorsStore.sortCollection"
      @create-new="surfaceDesignColorsStore.initCreateModalToggle"
      :sort-options="sortOptions"
    />
    <EmptyGrid
      v-if="surfaceDesignColorsStore.count === 0"
      @create-new="surfaceDesignColorsStore.initCreateModalToggle()"
    >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path d="M 7.1992188 1.9589844 C 6.6563438 1.9831082 6.1584439 2.3567331 6.0117188 2.9042969 L 2.3964844 16.398438 C 1.7912858 18.657137 3.141762 20.998313 5.4003906 21.603516 C 5.74769 21.696575 6.0968919 21.743701 6.4414062 21.748047 A 0.75 0.75 0 0 0 6.5 21.75 L 20.470703 21.75 C 21.16837 21.75 21.75 21.16837 21.75 20.470703 L 21.75 14.529297 A 0.75 0.75 0 0 0 21.695312 14.248047 C 21.691384 14.078601 21.653375 13.907431 21.578125 13.746094 L 19.066406 8.3613281 C 18.919015 8.0450752 18.652922 7.8176182 18.34375 7.7050781 C 18.034578 7.592538 17.683364 7.5967068 17.367188 7.7441406 L 12.964844 9.7949219 L 14.222656 5.1035156 C 14.403049 4.4296192 13.990342 3.7177167 13.316406 3.5371094 L 7.578125 2 C 7.4517622 1.9661398 7.3244976 1.9534173 7.1992188 1.9589844 z M 7.4042969 3.5058594 L 12.716797 4.9296875 L 9.15625 18.210938 C 8.9479016 18.988486 8.4329354 19.596543 7.7773438 19.939453 L 7.6640625 19.992188 C 7.6467252 20.00026 7.6307922 20.009867 7.6132812 20.017578 C 7.2679678 20.169636 6.8901883 20.251548 6.5 20.25 C 6.265887 20.249071 6.0267185 20.217977 5.7890625 20.154297 C 4.3134311 19.758899 3.4483486 18.262811 3.84375 16.787109 L 7.4042969 3.5058594 z M 17.800781 9.1972656 L 20.125 14.179688 L 10.599609 18.623047 C 10.601754 18.615222 10.603366 18.607456 10.605469 18.599609 L 12.458984 11.6875 L 17.800781 9.1972656 z M 20.25 15.777344 L 20.25 20.25 L 10.660156 20.25 L 20.25 15.777344 z M 6.5 16.849609 A 0.75 0.75 0 0 0 5.75 17.599609 A 0.75 0.75 0 0 0 6.5 18.349609 A 0.75 0.75 0 0 0 7.25 17.599609 A 0.75 0.75 0 0 0 6.5 16.849609 z "/>
        </svg>
      </template>
      <template v-slot:title>You haven't created any color palettes yet</template>
      <template v-slot:text>Here you can create your new palette and use it for your future designs.</template>
      <template v-slot:button-text>Create color palette</template>
    </EmptyGrid>
    <template v-if="surfaceDesignColorsStore.count > 0">
      <ElementsGrid>
        <Collection
          v-for="collection in surfaceDesignColorsStore.list"
          :key="collection.id"
          :collection="collection"
          selectedTab="colors"
          :designsCount="collection.colorsCount"
          @open="openLink(collection)"
          @edit="editModal"
          @delete="delModal"
          :prewiev="collection.colorsPreview"
        >
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 32 32">
              <path d="M8.7 28.7c-.5 0-.9-.1-1.4-.2-2.9-.8-4.6-3.7-3.8-6.6l4.8-18c.1-.4.3-.7.7-.9.3-.1.7-.2 1-.1l7.7 2c.4.1.7.3.9.7.2.3.2.7.1 1.1l-4.8 18c-.6 2.5-2.8 4-5.2 4zm1-24.3-4.8 18c-.3 1-.1 2.1.4 3 .5.9 1.4 1.6 2.4 1.8 2.1.6 4.2-.7 4.8-2.8l4.8-18-7.6-2z" />
              <path d="M27.3 28.8H8.7c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h18.6v-7.9c0-.4.3-.8.8-.8s.8.3.8.8v7.9c-.2.9-.8 1.6-1.6 1.6zM8.7 24.2c-.2 0-.3-.1-.5-.2-.3-.3-.4-.7-.1-1.1.1-.2.4-.3.6-.3.3 0 .6.2.7.5v.3c0 .2-.1.3-.2.5s-.3.3-.5.3z" class="st0"/>
              <path d="M10.6 28.3c-.3 0-.6-.2-.7-.4-.2-.4 0-.8.4-1L27.2 19l-3.4-7.1-7.5 3.5c-.4.2-.8 0-1-.4-.2-.4 0-.8.4-1l7.5-3.5c.7-.3 1.6 0 1.9.7l3.3 7.2c.3.7 0 1.6-.7 1.9L11 28.2c-.1.1-.3.1-.4.1z" />
            </svg>
          </template>
        </Collection>
      </ElementsGrid>
      <PaginationComponent
        :limit="surfaceDesignColorsStore.collectionsParams.limit"
        :offset="surfaceDesignColorsStore.collectionsParams.offset"
        :total="surfaceDesignColorsStore.count"
        @setOffset="setOffset"
      />
    </template>
    <ModalComponent @close="surfaceDesignColorsStore.initCreateModalToggle()" :show="surfaceDesignColorsStore.initCreateModal">
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 24 24">
          <path d="M 7.1992188 1.9589844 C 6.6563438 1.9831082 6.1584439 2.3567331 6.0117188 2.9042969 L 2.3964844 16.398438 C 1.7912858 18.657137 3.141762 20.998313 5.4003906 21.603516 C 5.74769 21.696575 6.0968919 21.743701 6.4414062 21.748047 A 0.75 0.75 0 0 0 6.5 21.75 L 20.470703 21.75 C 21.16837 21.75 21.75 21.16837 21.75 20.470703 L 21.75 14.529297 A 0.75 0.75 0 0 0 21.695312 14.248047 C 21.691384 14.078601 21.653375 13.907431 21.578125 13.746094 L 19.066406 8.3613281 C 18.919015 8.0450752 18.652922 7.8176182 18.34375 7.7050781 C 18.034578 7.592538 17.683364 7.5967068 17.367188 7.7441406 L 12.964844 9.7949219 L 14.222656 5.1035156 C 14.403049 4.4296192 13.990342 3.7177167 13.316406 3.5371094 L 7.578125 2 C 7.4517622 1.9661398 7.3244976 1.9534173 7.1992188 1.9589844 z M 7.4042969 3.5058594 L 12.716797 4.9296875 L 9.15625 18.210938 C 8.9479016 18.988486 8.4329354 19.596543 7.7773438 19.939453 L 7.6640625 19.992188 C 7.6467252 20.00026 7.6307922 20.009867 7.6132812 20.017578 C 7.2679678 20.169636 6.8901883 20.251548 6.5 20.25 C 6.265887 20.249071 6.0267185 20.217977 5.7890625 20.154297 C 4.3134311 19.758899 3.4483486 18.262811 3.84375 16.787109 L 7.4042969 3.5058594 z M 17.800781 9.1972656 L 20.125 14.179688 L 10.599609 18.623047 C 10.601754 18.615222 10.603366 18.607456 10.605469 18.599609 L 12.458984 11.6875 L 17.800781 9.1972656 z M 20.25 15.777344 L 20.25 20.25 L 10.660156 20.25 L 20.25 15.777344 z M 6.5 16.849609 A 0.75 0.75 0 0 0 5.75 17.599609 A 0.75 0.75 0 0 0 6.5 18.349609 A 0.75 0.75 0 0 0 7.25 17.599609 A 0.75 0.75 0 0 0 6.5 16.849609 z " />
        </svg>
      </template>
      <template v-slot:title>New palette</template>
      <template v-slot:description>How would you like to create a palette?</template>
      <template v-slot:extra>
        <div class="create-type-choose">
          <button @click="surfaceDesignColorsStore.setCreateNextStep('import')">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" class="icn">
              <path d="M6 2.75c-.958 0-1.75.792-1.75 1.75v16c0 .958.792 1.75 1.75 1.75h12c.958 0 1.75-.792 1.75-1.75V9.291c0-.44-.166-.864-.465-1.187a.75.75 0 0 0-.002 0L14.848 3.31a1.753 1.753 0 0 0-1.286-.561H6zm0 1.5h6.25V8.5c0 .958.792 1.75 1.75 1.75h4.25V20.5a.24.24 0 0 1-.25.25H6a.24.24 0 0 1-.25-.25v-16A.24.24 0 0 1 6 4.25zm7.75.084 4.09 4.416H14a.24.24 0 0 1-.25-.25V4.334zm-1.799 7.416a.75.75 0 0 0-.037.006.75.75 0 0 0-.012 0 .75.75 0 0 0-.015.004.75.75 0 0 0-.067.011.75.75 0 0 0-.029.01.75.75 0 0 0-.059.02.75.75 0 0 0-.035.013.75.75 0 0 0-.054.028.75.75 0 0 0-.036.02.75.75 0 0 0-.023.013l-3 2a.75.75 0 0 0-.209 1.041.75.75 0 0 0 1.041.209l1.834-1.223V18.5a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-4.598l1.834 1.223a.75.75 0 0 0 1.041-.209.75.75 0 0 0-.209-1.041l-3-2a.75.75 0 0 0-.023-.014.75.75 0 0 0-.036-.02.75.75 0 0 0-.054-.027.75.75 0 0 0-.035-.013.75.75 0 0 0-.059-.02.75.75 0 0 0-.03-.01.75.75 0 0 0-.066-.011.75.75 0 0 0-.015-.004.75.75 0 0 0-.012 0A.75.75 0 0 0 12 11.75a.75.75 0 0 0-.049 0z"/>
            </svg>
            <div>
              <h6>Import CSV</h6>
              <p>Upload CSV file and it'll convert it to a palette</p>
            </div>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow">
              <path d="M10 8.5L14 12.5L10 16.5" stroke="#09373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button @click="surfaceDesignColorsStore.setCreateNextStep('create')">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="icn">
              <path d="M5 3.25c-.958 0-1.75.792-1.75 1.75v14c0 .958.792 1.75 1.75 1.75h8.586c.464 0 .908-.184 1.236-.512l5.416-5.416c.328-.328.512-.772.512-1.236V5c0-.958-.792-1.75-1.75-1.75H5zm0 1.5h14a.24.24 0 0 1 .25.25v7.25H14c-.958 0-1.75.792-1.75 1.75v5.25H5a.24.24 0 0 1-.25-.25V5A.24.24 0 0 1 5 4.75zm9 9h5.19l-.012.012-5.416 5.416-.012.011V14a.24.24 0 0 1 .25-.25z" />
            </svg>
            <div>
              <h6>Create from scratch</h6>
              <p>Blank template</p>
            </div>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 8.5L14 12.5L10 16.5" stroke="#09373D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </template>
    </ModalComponent>

    <ModalComponent @close="surfaceDesignColorsStore.createModalToggle()" :show="surfaceDesignColorsStore.createModal" >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 24 24">
          <path d="M 7.1992188 1.9589844 C 6.6563438 1.9831082 6.1584439 2.3567331 6.0117188 2.9042969 L 2.3964844 16.398438 C 1.7912858 18.657137 3.141762 20.998313 5.4003906 21.603516 C 5.74769 21.696575 6.0968919 21.743701 6.4414062 21.748047 A 0.75 0.75 0 0 0 6.5 21.75 L 20.470703 21.75 C 21.16837 21.75 21.75 21.16837 21.75 20.470703 L 21.75 14.529297 A 0.75 0.75 0 0 0 21.695312 14.248047 C 21.691384 14.078601 21.653375 13.907431 21.578125 13.746094 L 19.066406 8.3613281 C 18.919015 8.0450752 18.652922 7.8176182 18.34375 7.7050781 C 18.034578 7.592538 17.683364 7.5967068 17.367188 7.7441406 L 12.964844 9.7949219 L 14.222656 5.1035156 C 14.403049 4.4296192 13.990342 3.7177167 13.316406 3.5371094 L 7.578125 2 C 7.4517622 1.9661398 7.3244976 1.9534173 7.1992188 1.9589844 z M 7.4042969 3.5058594 L 12.716797 4.9296875 L 9.15625 18.210938 C 8.9479016 18.988486 8.4329354 19.596543 7.7773438 19.939453 L 7.6640625 19.992188 C 7.6467252 20.00026 7.6307922 20.009867 7.6132812 20.017578 C 7.2679678 20.169636 6.8901883 20.251548 6.5 20.25 C 6.265887 20.249071 6.0267185 20.217977 5.7890625 20.154297 C 4.3134311 19.758899 3.4483486 18.262811 3.84375 16.787109 L 7.4042969 3.5058594 z M 17.800781 9.1972656 L 20.125 14.179688 L 10.599609 18.623047 C 10.601754 18.615222 10.603366 18.607456 10.605469 18.599609 L 12.458984 11.6875 L 17.800781 9.1972656 z M 20.25 15.777344 L 20.25 20.25 L 10.660156 20.25 L 20.25 15.777344 z M 6.5 16.849609 A 0.75 0.75 0 0 0 5.75 17.599609 A 0.75 0.75 0 0 0 6.5 18.349609 A 0.75 0.75 0 0 0 7.25 17.599609 A 0.75 0.75 0 0 0 6.5 16.849609 z " />
        </svg>
      </template>
      <template v-slot:title>New palette</template>
      <template v-slot:description>Create name for new palette</template>
      <template v-slot:extra>
        <label class="new-collection-field">
          <span>Palette name</span>
          <input type="text" placeholder="" v-model="surfaceDesignColorsStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.createModalToggle()">Cancel</ButtonSecondary>
        <ButtonPrimary
          class="small"
          :disabled="surfaceDesignColorsStore.collectionName?.length === 0"
          @click.native="surfaceDesignColorsStore.create($router)"
        >
          Continue
        </ButtonPrimary>
      </template>
    </ModalComponent>

    <ModalComponent @close="surfaceDesignColorsStore.closeImportModal()" :show="surfaceDesignColorsStore.importModal" class="create-csv-modal">
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 32 33">
          <path d="M8 3.75a2.096 2.096 0 0 0-2.084 2.084v21.332c0 1.142.942 2.084 2.084 2.084h16a2.096 2.096 0 0 0 2.084-2.084V12.223c0-.525-.198-1.031-.555-1.416l-5.916-6.389a2.086 2.086 0 0 0-1.529-.668H8zm0 1.5h8.582v5.916c0 1.142.942 2.084 2.084 2.084h5.918v13.916c0 .33-.253.584-.584.584H8a.574.574 0 0 1-.584-.584V5.834c0-.331.253-.584.584-.584zm10.082 0h.002c.163 0 .317.068.428.188l5.845 6.312h-5.691a.574.574 0 0 1-.584-.584V5.25zM12 18.416a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-8zm0 4a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-8z" />
        </svg>
      </template>
      <template v-slot:title>{{ surfaceDesignColorsStore.csvLoading ? 'Hold a minute...' : 'Import CSV'}}</template>
      <template v-slot:description>{{ surfaceDesignColorsStore.csvLoading ? 'We are converting your file...' : 'Please upload or drag your file here'}}</template>
      <template v-slot:extra v-if="!surfaceDesignColorsStore.csvLoading">
        <label class="import-csv-file">
          <input type="file" name="csv-file" @change="surfaceDesignColorsStore.addCSV">
          <div class="empty-placeholder" v-if="surfaceDesignColorsStore.csvFile === null">
            <ButtonPrimary class="small">
              <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                  <path d="M10 1.75a.75.75 0 0 0-.197.027.75.75 0 0 0-.31.174.75.75 0 0 0-.024.02.75.75 0 0 0-.006.006l-4.16 4.16a.75.75 0 0 0 0 1.06.75.75 0 0 0 1.06 0L9.25 4.311v9.857a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V4.311l2.887 2.886a.75.75 0 0 0 1.06 0 .75.75 0 0 0 0-1.06l-4.134-4.133a.75.75 0 0 0-.108-.098.75.75 0 0 0-.002-.002A.75.75 0 0 0 10 1.75zm-5 15a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h10a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75H5z" />
                </svg>
              </template>
              <slot name="button-text">Upload file</slot>
            </ButtonPrimary>
            <span>or Drag & Drop</span>
          </div>
          <div class="filled-placeholder" v-else>
            <span>{{ surfaceDesignColorsStore.csvFile.name }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" @mouseup="surfaceDesignColorsStore.removeCSV()">
              <path d="M6 5.248a.75.75 0 0 0-.531.22.75.75 0 0 0 0 1.063L10.937 12 5.47 17.469a.75.75 0 0 0 0 1.062.75.75 0 0 0 1.062 0L12 13.063l5.469 5.468a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.062L13.063 12l5.468-5.469a.75.75 0 0 0 0-1.062A.75.75 0 0 0 18 5.25a.75.75 0 0 0-.531.219L12 10.937 6.531 5.47A.75.75 0 0 0 6 5.248z" />
            </svg>
          </div>
        </label>
        <div class="error-message" v-if="surfaceDesignColorsStore.invalidFileType">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
            <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21c4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9Zm0-10v5"/>
            <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.9502 8h.1v.1h-.1V8Z"/>
          </svg>
          Invalid file type (must be csv only)
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16"
            @click="surfaceDesignColorsStore.invalidFileType = false"
          >
            <path stroke="#FFCBCB" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 12 4 4m8 0-8 8"/>
          </svg>
        </div>
        <InputField
          :error="!surfaceDesignColorsStore.delimiterOk"
          v-model="surfaceDesignColorsStore.csvFileInfo.delimiter"
          @input="surfaceDesignColorsStore.changedDelimiter = true"
          placeholder="“,” or “;”">
          <template v-slot:top-label>
            Delimiter*
          </template>
          <template v-slot:error-text>
            Must be one character “,” or “;”
          </template>
        </InputField>
        <p class="sample-text">Not sure if your file will be read correctly? <a href="https://cdn.patternfast.com/Template_Colors+for+import.csv" target="_blank">Download our template</a> to check.</p>
      </template>
      <template v-slot:extra v-else>
        <div class="csv-preloader">
          <div class="bar"></div>
        </div>
      </template>
      <template v-slot:buttons v-if="!surfaceDesignColorsStore.csvLoading">
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.importModalToggle()">Cancel</ButtonSecondary>
        <ButtonPrimary
          class="small"
          :disabled="surfaceDesignColorsStore.csvFile === null && surfaceDesignColorsStore.csvFile?.type !== 'text/csv'"
          @click.native="surfaceDesignColorsStore.prepareCSV()"
        >
          Continue
        </ButtonPrimary>
      </template>
    </ModalComponent>

    <ModalComponent @close="surfaceDesignColorsStore.commitImportModalToggle()" :show="surfaceDesignColorsStore.commitModal" class="commit-import-modal">
      <template v-slot:icon></template>
      <template v-slot:title>Check the imported palette</template>
      <template v-slot:description>Check that all colors are read correctly</template>
      <template v-slot:extra>
        <div class="columns-block-container">
          <div class="error-message">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21c4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9Zm0-10v5"/>
              <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.9502 8h.1v.1h-.1V8Z"/>
            </svg>
            Check that all colors are read correctly. If not, check that the delimiter is specified correctly.
            <svg class="error-message__close" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16"
              @click="surfaceDesignColorsStore.requiredFieldError = false"
            >
              <path stroke="#FFCBCB" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 12 4 4m8 0-8 8"/>
            </svg>
          </div>
          <div class="error-message" v-if="surfaceDesignColorsStore.requiredFieldError">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21c4.9706 0 9-4.0294 9-9 0-4.97056-4.0294-9-9-9-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9Zm0-10v5"/>
              <path stroke="#F52727" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.9502 8h.1v.1h-.1V8Z"/>
            </svg>
            Nothing to import. Please select at least one color format to proceed.<br>Choose a color name and at least one value type — HEX, RGB or Pantone — before confirming.
            <svg class="error-message__close" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width="16" height="16"
              @click="surfaceDesignColorsStore.requiredFieldError = false"
            >
              <path stroke="#FFCBCB" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 12 4 4m8 0-8 8"/>
            </svg>
          </div>
          <div
            class="column-block"
            v-for="(column, key) in surfaceDesignColorsStore.csvFileInfo.cols"
            :key="key">
            <h5>{{ key }}</h5>
            <div class="data">
              <p v-for="(row, i) in surfaceDesignColorsStore.csvFileInfo.rows" :key="i">{{ row[key] }}</p>
            </div>
            <SelectField
              :class="surfaceDesignColorsStore.requiredFieldError ? 'error' : ''"
              :value="column"
              :options="surfaceDesignColorsStore.columnsImportOptions"
              @change="(v) => surfaceDesignColorsStore.csvFileInfo.cols[key] = v"
            >
              <template v-slot:top-label>Action</template>
            </SelectField>
          </div>
        </div>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.anotherFileModalToggle()">Upload another file</ButtonSecondary>
        <ButtonPrimary
          class="small"
          :disabled="!surfaceDesignColorsStore.selectedColsIsUniq && !surfaceDesignColorsStore.selectedColsIsValid"
          @click.native="surfaceDesignColorsStore.importCSV($router)"
        >
          Confirm
        </ButtonPrimary>
      </template>
    </ModalComponent>

    <ModalComponent @close="surfaceDesignColorsStore.closeCsvErrorModal()" :show="surfaceDesignColorsStore.csvError">
      <template v-slot:icon></template>
      <template v-slot:title>Unable to import file</template>
      <template v-slot:description>Your file may have errors. Please check it and try again.</template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.csvError = false">Close</ButtonSecondary>
        <ButtonPrimary
          class="small"
          @click.native="() => {
            surfaceDesignColorsStore.csvError = false
            surfaceDesignColorsStore.importModalToggle()
          }"
        >
          Upload again
        </ButtonPrimary>
      </template>
    </ModalComponent>

    <ModalComponent @close="surfaceDesignColorsStore.renameModalToggle()" :show="surfaceDesignColorsStore.renameModal" >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 32 32">
          <path d="M21.334 5.14a2.08 2.08 0 0 0-1.475.606l-4.39 4.39L4.803 20.804a.75.75 0 0 0-.219.531v5.332a.75.75 0 0 0 .75.75h5.332a.75.75 0 0 0 .531-.219L21.863 16.53l4.39-4.388a2.096 2.096 0 0 0 0-2.948l-3.446-3.447a2.076 2.076 0 0 0-1.473-.605zm0 1.49c.148 0 .295.06.412.177l3.447 3.447a.574.574 0 0 1 0 .826l-3.859 3.86-4.271-4.272 3.859-3.861a.581.581 0 0 1 .412-.176zM16 11.73 20.273 16l-9.918 9.916H6.084v-4.271L16 11.729z"/>
        </svg>
      </template>
      <template v-slot:title>Rename collection</template>
      <template v-slot:extra>
        <label class="edit-collection-field">
          <span>Collection Name</span>
          <input type="text" placeholder="" v-model="surfaceDesignColorsStore.collectionName">
        </label>
      </template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.renameModalToggle()">Cancel</ButtonSecondary>
        <ButtonPrimary
          class="small"
          :disabled="surfaceDesignColorsStore.collectionName?.length === 0"
          @click.native="surfaceDesignColorsStore.updateCollection()"
        >
          Rename
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ModalComponent @close="surfaceDesignColorsStore.delCollectionModalToggle()" type="error" :show="surfaceDesignColorsStore.delCollectionModal" >
      <template v-slot:title>Delete collection</template>
      <template v-slot:description>Are you sure? You will lose the colors that are in it</template>
      <template v-slot:buttons>
        <ButtonSecondary class="small" @click.native="surfaceDesignColorsStore.delCollectionModalToggle()">Cancel</ButtonSecondary>
        <ButtonPrimary class="small" @click.native="surfaceDesignColorsStore.deleteCollection()">
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 21 20">
              <path d="M8 1.75c-.866 0-1.584.718-1.584 1.584v.916H3.834a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h.916v10.916c0 .866.718 1.584 1.584 1.584h8.332c.866 0 1.584-.718 1.584-1.584V5.75h.916a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-2.582v-.916c0-.866-.718-1.584-1.584-1.584H8zm0 1.5h5c.055 0 .084.03.084.084v.916H7.916v-.916c0-.055.03-.084.084-.084zm-1.75 2.5h8.5v10.916c0 .055-.03.084-.084.084H6.334c-.055 0-.084-.03-.084-.084V5.75z" color="#000" style="-inkscape-stroke:none"/>
            </svg>
          </template>
          Delete
        </ButtonPrimary>
      </template>
    </ModalComponent>
    <ExpiredDemoMode />
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignColorsStore } from '@/store/pinia/surfaceDesignColors'

import TopPanel from '@/components/SurfaceDesign/TopPanel.vue'
import EmptyGrid from '@/components/Atoms/EmptyGrid.vue'
import ElementsGrid from '@/components/Atoms/ElementsGrid.vue'
import Collection from '@/components/SurfaceDesign/Collection.vue'
import ModalComponent from '@/components/Atoms/ModalComponent.vue'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import InputField from '@/components/Atoms/InputField.vue'
import SelectField from '@/components/Atoms/SelectField.vue'
import PaginationComponent from '@/components/Atoms/PaginationComponentLimit.vue'
import ExpiredDemoMode from '@/components/ExpiredDemoMode.vue'

export default {
  name: 'SurfaceDesignColors',
  components: {
    ExpiredDemoMode,
    TopPanel,
    EmptyGrid,
    ElementsGrid,
    Collection,
    ModalComponent,
    ButtonPrimary,
    ButtonSecondary,
    SelectField,
    PaginationComponent,
    InputField,
  },
  computed: {
    ...mapStores(useSurfaceDesignColorsStore),
  },
  data: () => ({
    sortOptions: [
      { name: 'Sort by', value: '' },
      { name: 'Name', value: 'title' },
      { name: 'Last edited', value: 'updatedAt' },
      { name: 'Number of colors', value: 'colorsCount' },
    ],
  }),
  methods: {
    async openLink (collection) {
      this.surfaceDesignColorsStore.selectCollectionId(collection.id)
      this.surfaceDesignColorsStore.selectCollection(collection)
      this.surfaceDesignColorsStore.selectedCollectionName = collection.title
      this.$router.push('/user/surface-design-color/' + collection.id)
    },
    delModal (payload) {
      this.surfaceDesignColorsStore.delCollectionModalToggle()
      this.surfaceDesignColorsStore.collectionId = payload.id
    },
    editModal (payload) {
      this.surfaceDesignColorsStore.renameModalToggle()
      this.surfaceDesignColorsStore.collectionId = payload.id
      this.surfaceDesignColorsStore.collectionName = payload.title
    },
    async setOffset (offset) {
      this.surfaceDesignColorsStore.collectionsParams.offset = offset
      await this.surfaceDesignColorsStore.getList()
    },
  },
  async beforeMount () {
    await this.surfaceDesignColorsStore.getList()
  },
}
</script>

<style lang="scss">
.surface-design-colors {
  padding: 0 16px 40px 40px;

  .create-csv-modal {
    .error-message {
      margin-bottom: 24px;
      align-items: center;
    }
    .modal-component .extra {
      max-width: 330px;
    }
  }

  .error-message {
    display: flex;
    gap: 16px;
    padding: 12px;
    color: var(--System-Error);
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid #FFCBCB;
    background: rgba(245, 39, 39, 0.05);
    line-height: 150%;
    svg {
      min-width: 24px;
    }
    &__close {
      cursor: pointer;
    }
  }

  .create-type-choose {
    display: flex;
    flex-direction: column;
    gap: 16px;

    button {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      gap: 16px;
      box-sizing: border-box;
      padding: 12px;

      border-radius: 8px;
      border: 1px solid var(--Dividers);
      background: var(--Background);

      font-style: normal;
      font-weight: 400;
      line-height: 150% !important;

      svg {
        width: 24px;
        height: 25px;
        flex-shrink: 0;

        &.icn {
          fill: var(--Icons-Icons_Secondary);
        }
      }

      div {
        flex-grow: 1;
        text-align: left;
      }

      h6 {
        color: var(--Text-Text_Primary);
        font-family: "DM Sans";
        font-size: 16px;
        margin: 0;
        margin-bottom: 4px;
      }
      p {
        color: var(--Text-Text_Secondary);
        font-family: "DM Sans";
        font-size: 14px;
        margin: 0;
      }
    }
  }

  .import-csv-file {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 150px;
    position: relative;
    margin: 0;
    padding: 0;
    margin-bottom: 12px;

    border-radius: 12px;
    border: 1px dashed var(--Dividers);
    background: var(--Surface-Hover);
    overflow: hidden;

    input[type="file"] {
      position: absolute;
      width: 100%;
      height: 100%;
      font-size: 0;
      background-color: rgba(0,0,0,0);
      cursor: pointer;
      z-index: 100;
      &::file-selector-button {
        display: none;
      }
    }

    .empty-placeholder {
      text-align: center;
      .btn {
        margin-bottom: 7px;
      }
      span {
        color: var(--Primary-Shades-Primary);
        font-family: "DM Sans";
        font-size: 14px;
        line-height: 150%;
      }
    }

    .filled-placeholder {
      position: relative;
      z-index: 101;
      display: flex;
      padding: 8px 8px 8px 16px;
      align-items: center;
      gap: 4px;
      margin: 8px;

      border-radius: 8px;
      border: 1px solid var(--Dividers);
      background: var(--Background);

      span {
        color: var(--Text-Text_Primary, #1D1F29);
        font-family: "DM Sans";
        font-size: 16px;
        line-height: 150%;
      }
      svg {
        flex-shrink: 0;
        fill: var(--secondary);
        display: block;
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }

  .sample-text {
    color: var(--Text-Text_Secondary);
    text-align: center;
    font-family: "DM Sans";
    font-size: 16px;
    line-height: 150%;
    margin-top: 24px;

    a, a:visited {
      color: var(--Primary-Button-Surface);
      text-decoration: underline;
    }
    a:hover {
      text-decoration: none;
    }
  }

  .csv-preloader {
    display: block;
    width: 100%;
    height: 8px;
    overflow: hidden;
    border-radius: 20px;
    background: var(--input_hover);

    .bar {
      display: block;
      width: 100%;
      height: 8px;
      overflow: hidden;
      border-radius: 20px;
      background: var(--accent);
      animation: 1.5s ease-in-out 0ms infinite alternate running preloader;
    }
  }

  .commit-import-modal {
    .modal-component {
      width: 100%;
      max-width: 684px;
      .extra {
        max-width: 564px;
      }
    }
  }

  .columns-block-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: 432px;
    overflow-y: auto;

    .column-block {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 152px;
      box-sizing: border-box;
      padding: 32px;

      border-radius: 16px;
      border: 1px solid var(--Dividers);
      background: var(--Surface);

      h5 {
        color: var(--Text-Text_Primary);
        font-family: "DM Sans";
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        width: 108px;
        margin: 0;
      }

      .data {
        flex-grow: 1;
        p {
          color: var(--Text-Text_Primary);
          font-family: "DM Sans";
          font-size: 16px;
          line-height: 150%;
        }
      }

      .select-field.error {
        span {
          color: var(--System-Error);
        }
        input {
          border-color: var(--System-Error);
        }
      }
      .select-field {
        width: 200px;

        // .dropdown.bottom {
        //   top: 48px;
        // }
      }
    }
  }
}

.new-collection-field, .edit-collection-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  row-gap: 8px;

  span {
    color: var(--Text-Text_Secondary);
    font-family: "DM Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  input {
    border-radius: 8px;
    border: 1px solid var(--Dividers);
    background: var(--Background);
    padding: 10px 12px;

    color: var(--Text-Text_Primary);
    font-family: "DM Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
}

@media (max-width: 960px) {
  .surface-design-colors {
    .elements-grid {
      grid-template-columns: 1fr 1fr;
    }
  }
}
@media (max-width: 760px) {
  .surface-design-colors {
    padding: 0 0 40px 0 !important;

    h1 {
      font-size: 24px !important;
      button {
        display: block;
      }
    }
    .columns-block-container .column-block {
      flex-wrap: wrap;
      gap: 16px;
      height: auto;
      h5, .data {
        width: calc(50% - 16px);
      }
      .select-field {
        width: 100%;
      }
    }
  }
}

@media (min-width: 761px) and (max-width: 1194px) {
  .surface-design-colors {
    h1 {
      margin-bottom: 0;
    }

    .user-top-panel {
      .left-side {
        margin-bottom: 16px;
      }
    }
  }
}

@keyframes preloader {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
</style>
